// extracted by mini-css-extract-plugin
module.exports = {"container":"_1v7aF","toggleButton":"_3OOLH","expanded":"OhmLz","textContainer":"_3nWgP"};